<div class="container">
    <div class="item-row first">
        <div class="subject-area" #subject>
            <span tid="blastemail_detail_blastemail_subject" [title]="blastEmail.subject">{{blastEmail.subject}}</span>
        </div>
    </div>
    <div class="item-row second">
        <div tid="blastemail_detail_blastemail_info" #submitInfo class="submit-info-area" [title]="getSubmitInfoTitle()">
            <span class="blastemail-type-info">{{blastEmail.type}}</span> from
            <span class="source-info" *ngIf="blastEmail.contact">{{blastEmail.contact.name}}</span>
            <span *ngIf="blastEmail.contact && blastEmail.contact.company"> of {{blastEmail.contact.company}}</span>
            <span class="source-info" *ngIf="!blastEmail.contact">{{blastEmail.fromPersonName}}</span>
            <span *ngIf="!blastEmail.contact">({{blastEmail.fromEmailAddress}})</span>
            on <span>{{getWeekdayByDate(blastEmail.time)}},&nbsp;</span>
            <span>{{blastEmail.time | date: 'dd MMM yyyy, HH:mm'}}</span>
        </div>
        <div tid="blastemail_detail_blastemail_attachment_clip_count" class="attachment-area" *ngIf="blastEmail.attachments.size > 0"
            (click)="onShowAttachmentList($event)">
            <smart-icon name="attachment"></smart-icon>
            <div class="number">&nbsp;{{blastEmail.attachments.size}}</div>
        </div>
        <div tid="blastemail_detail_blastemail_expand" class="toggle-area">
            <smart-icon [name]="collapsed ? 'angle-up' : 'angle-down'" (click)="onToggle()"></smart-icon>
        </div>
    </div>
    <!-- <div class="attachment-icon-click">
        <popover [config]="popoverConfig"></popover>
    </div> -->
</div>